export default __webpack_public_path__ + "static/media/logo.77aad635.svg";